import { memo } from 'react';
import { EApplicantOfferPGKeys } from 'types';
import { TableCellProps } from '../../../types';
import { Flex } from '@chakra-ui/react';
import { defaultHeaderRenderer } from '../../headers';
import { IColumn } from '../../types';
import { UNKNOWN_VALUE } from '../helpers';

const Formatter = memo(function formatter(cellProps: TableCellProps) {
  const result = cellProps.row.nationality || UNKNOWN_VALUE;
  return (
    <Flex height="100%" width="100%" flexDirection={'column'}>
      {result}
    </Flex>
  );
});

export const NationalityColumn = (): IColumn => ({
  item: {
    key: EApplicantOfferPGKeys.NATIONALITY,
    name: 'Nationality',
    width: 'minmax(104px, .75fr)',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    responsive: true,
    formatter: Formatter,
  },
  visible: () => true,
});
